module.exports = __webpack_public_path__ + "img/38.302d1e6b.jpg";